import { render, staticRenderFns } from "./UpdateTool.vue?vue&type=template&id=0054905c&"
import script from "./UpdateTool.vue?vue&type=script&lang=ts&"
export * from "./UpdateTool.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports